export function countryToLanguageCode(countryCode: string): string {
  const map: Record<string, string> = {
    KR: 'ko',
    US: 'en',
    JP: 'ja',
    TW: 'zh',
    TH: 'th',
  };

  return map[countryCode.toUpperCase()] ?? 'ko'; // 기본값은 ko
}
